import { useToastContext } from "@ttc3k/trekker";
import {
  EnumPublicationStatusStatus,
  EnumVersionedEntityReferenceType,
  OperatorByIdDocument,
  useCreatePublicationStatusMutation,
} from "gql/generated";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLoggedInAs } from "shared/hooks";

const APPROVE_OP_MODAL_DISABLED_KEY = "APPROVE_OP_MODAL_DISABLED";

export const useApproveOperator = (_entityId?: string, _versionId?: string) => {
  const { t } = useTranslation();
  const { toastFactory } = useToastContext();
  const loggedInAs = useLoggedInAs();
  const [createPublicationStatus] = useCreatePublicationStatusMutation();
  const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
  const isApproveOpModalDisabled = localStorage.getItem(
    APPROVE_OP_MODAL_DISABLED_KEY,
  );

  const approveOperator = async () => {
    try {
      await createPublicationStatus({
        variables: {
          record: {
            entity: {
              _entityId,
              _versionId,
              type: EnumVersionedEntityReferenceType.Operator,
            },
            organization: loggedInAs?.entityId,
            status: EnumPublicationStatusStatus.Approved,
          },
        },
        refetchQueries: [OperatorByIdDocument],
      });
    } catch {
      toastFactory.create({
        title: t("core:ERROR.TITLE"),
        description: t("directory:OPERATOR.ERROR.APPROVING_OPERATOR"),
      });
    }
  };

  const handleApproveOperatorClick = () => {
    if (isApproveOpModalDisabled && Boolean(isApproveOpModalDisabled)) {
      approveOperator();
    } else {
      setIsApproveModalOpen(true);
    }
  };

  const handleApproveOperatorClickInModal = (
    isDisableModalSelected: boolean,
    isSavingAndApproving: boolean,
  ) => {
    if (isDisableModalSelected) {
      localStorage.setItem(
        APPROVE_OP_MODAL_DISABLED_KEY,
        isDisableModalSelected.toString(),
      );
    }
    if (!isSavingAndApproving) {
      approveOperator();
    }
    setIsApproveModalOpen(false);
  };

  const onCloseApprovalModal = () => setIsApproveModalOpen(false);
  return {
    onApproveOperatorClickInModal: handleApproveOperatorClickInModal,
    onApproveOperatorClick: handleApproveOperatorClick,
    isApproveModalOpen,
    onCloseApprovalModal,
    isApproveOpModalDisabled,
  };
};
